import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

/**
 * App-level guard to ensure suspended users are always sent to /auth.
 * This complements ProtectedRoute and catches cases where a page isn't wrapped.
 */
export function SuspensionGate({ children }: { children: ReactNode }) {
  const { suspendedReason } = useAuth();
  const location = useLocation();

  if (suspendedReason && location.pathname !== "/auth") {
    return <Navigate to="/auth" replace />;
  }

  return <>{children}</>;
}
